import { message } from 'antd';
import { MembershipStatus, MembershipType, ScheduledEmailType } from '../types/userTypes';
import styled from 'styled-components';
import { RegularText } from './typography';
import {
  CANCELLATION_REASON_1,
  CANCELLATION_REASON_2,
  CANCELLATION_REASON_3,
  CANCELLATION_REASON_4,
  CANCELLATION_REASON_5,
  CANCELLATION_REASON_6,
  CANCELLATION_REASON_7,
  CANCELLATION_REASON_8
} from './constants/labels';
import { api } from '../api/api';

export const capitalize = (text: string) => (text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()).replace('_', ' ');

export enum NotificationType {
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning'
}

export const notify = (content: string, type: NotificationType = NotificationType.ERROR) =>
  message[type](capitalize(content), 3);

export const getQueryString = (params: Object) => {
  return Object.keys(params)
    .map(k => {
      if (Array.isArray(params[k])) {
        return params[k].map(val => `${encodeURIComponent(k)}=${encodeURIComponent(val).replace('%2C', ',')}`).join('&');
      }
      const paramValue = encodeURIComponent(params[k]).replace('%2C', ',');
      return `${encodeURIComponent(k)}=${paramValue}`;
    })
    .join('&');
};

export const getSortingParams = (sortingParams: any) => sortingParams.map(s => `${s.property},${s.direction.toLowerCase()}`);

export const isSubscription = (type: MembershipType) =>
  [MembershipType.MONTHLY, MembershipType.SEMI_ANNUAL, MembershipType.ANNUAL].includes(type);

export const copyToClipboard = str => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

export const membershipTypeColors = {
  [MembershipType.LIFETIME]: 'volcano',
  [MembershipType.ORGANIZATION]: 'orange',
  [MembershipType.MONTHLY]: 'geekblue',
  [MembershipType.SEMI_ANNUAL]: 'geekblue',
  [MembershipType.ANNUAL]: 'geekblue',
  [MembershipType.OLD_USER]: 'gold',
  [MembershipType.INVITED]: 'volcano',
  [MembershipType.FREE_TRIAL]: 'default',
  [MembershipType.CANCELED]: 'red'
};

export const membershipStatusColors = {
  [MembershipStatus.ACTIVE]: 'green',
  [MembershipStatus.TRIAL]: 'default',
  [MembershipStatus.CANCELED]: 'red',
  [MembershipStatus.EXPIRED]: 'volcano'
};

export const cancellationReasonColors = {
  [CANCELLATION_REASON_1]: 'magenta',
  [CANCELLATION_REASON_2]: 'red',
  [CANCELLATION_REASON_3]: 'volcano',
  [CANCELLATION_REASON_4]: 'purple',
  [CANCELLATION_REASON_5]: 'gold',
  [CANCELLATION_REASON_6]: 'blue',
  [CANCELLATION_REASON_7]: 'green',
  [CANCELLATION_REASON_8]: 'cyan'
};

export const emailTypeColors = {
  [ScheduledEmailType.GIFT_MEMBERSHIP_REMINDER]: 'volcano',
  [ScheduledEmailType.MOBILE_SIGNUP_REMINDER]: 'orange',
  [ScheduledEmailType.RESET_TRIAL]: 'geekblue',
  [ScheduledEmailType.RESET_TRIAL_REMINDER]: 'geekblue',
  [ScheduledEmailType.TRIAL_EXPIRATION]: 'geekblue'
};

export const DatePreview = styled(RegularText)`
  display: block;
  width: max-content;
`;

export const hasValue = (value: any) => value !== undefined && value !== null;

// since admin is not prod ready app, we will skip this feature
// for local development and assume the testing is done through connecting to dev/stg
export const getSubdomain = (env: string) => {
  if (env === 'DEVELOPMENT') {
    return 'dev';
  }
  if (env === 'STAGE') {
    return 'stg';
  }
  return 'dig';
};

export const initStudentSession = async (studentId: number) => {
  const res = await api.initCoachStudentSession(studentId);
  if (res.status !== 200) {
    console.log('Init session error');
    return;
  }
  window.open(`https://app.shovelapp.io/init-coach-session/${res.data?.refreshToken}`, '_blank');
};
